var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F97316"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.5618 19.5039C14.812 17.5021 16.5136 16 18.5309 16H25.4686C27.4859 16 29.1875 17.5021 29.4377 19.5039L30.4377 27.5039C30.7361 29.8913 28.8746 32 26.4686 32H17.5309C15.1249 32 13.2633 29.8913 13.5618 27.5039L14.5618 19.5039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 15C18.25 12.9289 19.9289 11.25 22 11.25C24.0711 11.25 25.75 12.9289 25.75 15V17C25.75 17.4142 25.4142 17.75 25 17.75C24.5858 17.75 24.25 17.4142 24.25 17V15C24.25 13.7574 23.2426 12.75 22 12.75C20.7574 12.75 19.75 13.7574 19.75 15V17C19.75 17.4142 19.4142 17.75 19 17.75C18.5858 17.75 18.25 17.4142 18.25 17V15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6525 25.6318C25.8559 25.9926 25.7283 26.45 25.3675 26.6535C24.1523 27.3386 23.1057 27.748 22.002 27.7501C20.897 27.7523 19.8483 27.346 18.6283 26.652C18.2683 26.4472 18.1424 25.9893 18.3473 25.6293C18.5521 25.2692 19.01 25.1434 19.37 25.3482C20.5062 25.9946 21.2813 26.2515 21.9991 26.2501C22.7183 26.2487 23.4936 25.988 24.6308 25.3468C24.9916 25.1434 25.449 25.271 25.6525 25.6318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTools);
export default __webpack_public_path__ + "static/media/total-tools.577e4b49ae42fcc02fec5760b7fc7d50.svg";
export { ForwardRef as ReactComponent };